import { NavType } from '../../interfaces';

export default function Navbar({ title = 'Supermatch', description = 'Supermatch' }: NavType): JSX.Element {
    return (
        <header>
            <title>{title}</title>
            <meta name="description" content={description} />
        </header>
    );
}
